import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../components/mybids/mybids.css";
import { useNavigate } from "react-router-dom";
import placeimg from "../../myimgs/Group 193.png";

const MyBids = () => {
  const [auctions, setAuctions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const handleViewDetails = (id, propeId, listedBy, email) => {
    const encodedListedBy = encodeURIComponent(listedBy || "");
    const encodedEmail = encodeURIComponent(email || "");
    // Open the route in a new tab with query params
    const url = `/propertyDetail?id=${id}&propeId=${propeId}&listedBy=${encodedListedBy}&email=${encodedEmail}`;
    window.open(url, "_blank");
  };
  useEffect(() => {
    const fetchBids = async () => {
      const userId = localStorage.getItem("userId");
      if (!userId) return;

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/bid/user/${userId}`
        );
        setAuctions(response.data.data || []);
      } catch (error) {
        console.error("Error fetching bids:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBids();
  }, []);

  // timersss  ...
  function Countdown({ start, end }) {
    const [timeLeft, setTimeLeft] = useState("");

    const formatDateTime = (dateString) => {
      const date = new Date(dateString);
      if (isNaN(date)) return "";
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${day}-${month}-${year}, ${hours}:${minutes}`;
    };

    const getRemainingTime = (startTime, endTime) => {
      if (!startTime || !endTime) return "";

      const now = new Date();
      const startDate = new Date(startTime);
      const endDate = new Date(endTime);

      if (isNaN(startDate) || isNaN(endDate)) return "";

      // Before start
      if (now < startDate) {
        return (
          <>
            Starts In:
            <br />
            {formatDateTime(startDate)}
          </>
        );
      }

      const diff = endDate - now;
      if (diff <= 0) return "Ended";

      // When started, show Ends In
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      return (
        <>
          Ends In:
          <br />
          {`${days}D : ${hours}H : ${minutes}M : ${seconds}s`}
        </>
      );
    };

    useEffect(() => {
      const interval = setInterval(() => {
        setTimeLeft(getRemainingTime(start, end));
      }, 1000);

      return () => clearInterval(interval);
    }, [start, end]);

    return <h3>{timeLeft || ""}</h3>;
  }

  // timersss  ...
  if (loading)
    return (
      <div className="loader-wrapper">
        <div className="loader"></div>
      </div>
    );
  return (
    <div className="auction-container">
      <h2 className="auction-title">My Offers</h2>
      {!auctions.length && !loading && (
        <p style={{ textAlign: "center", marginTop: "10px" }}>No data found</p>
      )}
      <div className="auction-list">
        {auctions.map((auction) => (
          <div key={auction.id} className="auction-card kjui">
            {/* Image */}
            <img
              src={
                auction.propertyImages?.[0]?.imageUrl
                  ? auction.propertyImages[0].imageUrl
                  : placeimg
              }
              alt="Property"
            />

            <div className="auction-info">
              <div className="auction-details">
                {(auction.listingId || auction.propeId) && (
                  <h3 className="mls">
                    {auction.listingId ? (
                      <>
                        <strong>MLS No:</strong> {auction.listingId}
                      </>
                    ) : (
                      <>
                        <strong>Property Id:</strong> {auction.propeId}
                      </>
                    )}
                  </h3>
                )}
                <p className="listed-by">
                  Listed by <span>{auction.user?.name}</span>
                </p>

                {/* Address */}
                <h3 className="address">{auction.unparsedAddress}</h3>

                <div className="property-specs">
                  {auction.bedroomsTotal > 0 && (
                    <span className="spec">🛏{auction.bedroomsTotal}bed</span>
                  )}

                  {auction.bathroomsTotalInteger > 0 && (
                    <span className="spec">
                      🛁{auction.bathroomsTotalInteger}bath
                    </span>
                  )}

                  {auction.lotSizeArea > 0 && (
                    <span className="spec">📐{auction.lotSizeArea}ft</span>
                  )}
                </div>

                {/* Countdown Timer */}
                <div className="timebtn lko">
                  <Countdown
                    start={auction.biddingDetails?.bidingStartDateTime}
                    end={auction.biddingDetails?.bidingEndDateTime}
                  />
                </div>
              </div>

              <div className="price-section">
                {/* <p className="price-label">Current Valuation</p> */}
                <p className="price-label">
                  {auction.biddingDetails == null
                    ? "Listing Price"
                    : auction.isBidEnd === false
                    ? "Listing Price"
                    : "Current Offer Price"}
                </p>
                <h4 className="prices">
                  {(() => {
                    const details = auction.biddingDetails;

                    // CASE 1: If biddingDetails exists
                    if (details) {
                      // If bid has ended → show listPrice
                      if (
                        details.isBidEnd !== null &&
                        details.isBidEnd === true
                      ) {
                        return `$${Number(auction.listPrice).toLocaleString()}`;
                      }

                      // If bid NOT ended → show currentAuctionAmount OR offerStartingPrice
                      return `$${Number(
                        details.currenntAuctionAmount ??
                          details.offerStartingPrice
                      ).toLocaleString()}`;
                    }

                    // CASE 2: If biddingDetails does NOT exist → show listPrice
                    return `$${Number(auction.listPrice).toLocaleString()}`;
                  })()}
                </h4>

                <button
                  className="view-btn"
                  onClick={() => {
                    const listedBy =
                      auction.user?.name || auction.originatingSystemName;
                    const email = auction.user?.email || "";
                    handleViewDetails(
                      auction.id,
                      auction.propeId,
                      listedBy,
                      email
                    );
                  }}
                >
                  View Details
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyBids;
